import React, { useState } from 'react';
import { EditAddressForm } from '../../profile/EditAddressForm';
import useAdminApi from '../../../hooks/admin/useAdminApi';
import { AddressResp, AddressType } from '../../../models/Addresses';
import { useTranslation } from 'react-i18next';
import SnackbarUtils from '../../../utils/SnackbarUtils';
import { Typography } from '@mui/material';

export const AdminUserAddress: React.FC<Props> = (props) => {
    const { address, type, userId, handleForceRefresh } = props;
    const admin = useAdminApi();
    const { t } = useTranslation();
    const [submitIsLoading, setSubmitIsLoading] = useState(false);

    const handleFormSubmitClose = (data) => {
        setSubmitIsLoading(true);
        const putData = {
            companyAddress: {
                type: type.toUpperCase(),
                ...data,
            },
        };
        admin
            .updateUserAddress(putData, userId, address.id)
            .then(() => {
                SnackbarUtils.success(
                    t('NOTIFICATION.ADDRESS_EDITED').toString()
                );
                handleForceRefresh();
            })
            .catch(() => {
                SnackbarUtils.error(
                    t('NOTIFICATION.ERROR_LOADING').toString()
                );
            })
            .finally(() => {
                setSubmitIsLoading(false);
            });
    };

    return (
        <>
            <Typography variant={'h4'} sx={{ paddingY: '15px' }}>
                {address.name}
            </Typography>
            <EditAddressForm
                address={{
                    type: type,
                    id: address.id,
                    data: address[type + 'Address'],
                }}
                submitForm={handleFormSubmitClose}
                setIsLoading={submitIsLoading}
            />
        </>
    );
};

interface Props {
    address: AddressResp;
    type: AddressType;
    userId: number;
    handleForceRefresh: () => void;
}
